<template>
    <section class="fibu-buchung-filter">
        <h3>Filter</h3>
        <b-form @submit="onSubmit" @reset="onReset">
            <b-form-group
                label-cols-sm="2"
                label="Zeitraum von:"
                label-for="inputFromDate"
                :label-size="size"
            >
                <b-datepicker
                    id="inputFromDate"
                    v-model="filter._from_date"
                    :size="size"
                />
            </b-form-group>
            <b-form-group
                label-cols-sm="2"
                label="Zeitraum bis:"
                label-for="inputToDate"
                :label-size="size"
            >
                <b-datepicker
                    id="inputToDate"
                    v-model="filter._to_date"
                    :size="size"
                />
            </b-form-group>
            <hr />
            <b-form-group
                label-cols-sm="2"
                label="Sortierung:"
                label-for="inputOrderBy"
                :label-size="size"
            >
                <b-select
                    id="inputOrderBy"
                    v-model="filter.orderby"
                    :options="orderBy"
                    :size="size"
                />
            </b-form-group>
            <hr />
            <b-form-group
                label-cols-sm="2"
                label="Mitglieder:"
                label-for="inputMitglieder"
                :label-size="size"
            >
                <CheckboxSelect
                    id="inputMitglieder"
                    v-model="filter._mitglied_id"
                    :selectSize="5"
                    :sortActive="true"
                    :isBusy="mitglieder.busy"
                    :options="mitglieder.options"
                    :size="size"
                />
            </b-form-group>
            <hr />
            <b-form-group
                label-cols-sm="2"
                label="Verwendungszweck:"
                label-for="inputVerwendungszweck"
                :label-size="size"
            >
                <b-input
                    id="inputVerwendungszweck"
                    v-model="filter.verwendungszweck"
                    :size="size"
                />
            </b-form-group>
            <b-form-group
                label-cols-sm="2"
                label="Nach bestimmtem Betrag suchen:"
                label-for="inputBetrag"
                description="Kann genutzt werden um fehlende oder überschüssige Beträge im Zusammenhang mit dem Jahresabschluss zu finden"
                :label-size="size"
            >
                <b-input
                    id="inputBetrag"
                    v-model="filter.betrag"
                    :size="size"
                />
            </b-form-group>
            <b-form-group
                label-cols-sm="2"
                label="Beglichene Posten anzeigen:"
                label-for="inputClosed"
                :label-size="size"
            >
                <input
                    type="checkbox"
                    id="inputClosed"
                    true-value="1"
                    false-value="0"
                    v-model="filter.closed"
                />
            </b-form-group>

            <div class="btns-full-width d-flex">
                <b-form-group>
                    <b-button variant="primary" @click="onSubmit" :size="size"
                    >Anzeigen</b-button
                    >
                    <b-button
                        type="reset"
                        variant="outline-danger"
                        :size="size"
                        class="ml-1"
                    >Felder zurücksetzen</b-button
                    >
                </b-form-group>
                <b-form-group>
                    <template v-if="mahnungen.busy">
                        <b-button
                            v-if="filter.closed === '0'"
                            :size="size"
                            variant="warning"
                            class="ml-1"
                        >
                            <Spinner small variant="light" />
                        </b-button>
                    </template>
                    <template v-else>
                        <b-button
                            v-if="filter.closed === '0'"
                            :size="size"
                            variant="warning"
                            class="ml-1"
                            :disabled="mahnungen.busy"
                            @click="sendMahnungsEvent"
                        >
                            Mahnungen erstellen
                        </b-button>
                    </template>
                </b-form-group>

            </div>
        </b-form>
    </section>
</template>

<script>
import Size from "@/mixins/Size/Size";
import { ApiFactory } from "@/api/ApiFactory.js";
import CheckboxSelect from "@/components/CheckboxSelect/CheckboxSelect";
import Spinner from "@/components/Spinner/Spinner.vue";


const FiBuBuchungApi = ApiFactory.get("fibuBuchung");

export default {
    name: "FiBuOPFilter",
    props: ["mitglieder", "mahnungen"],
    mixins: [Size],
    components: {
        Spinner,
        CheckboxSelect
    },
    data() {
        return {
            orderBy: [
                {
                    value: "id",
                    text: "ID"
                },
                {
                    value: "buchungsnr",
                    text: "Buchungs-Nr."
                },
                {
                    value: "datum",
                    text: "Datum"
                }
            ],
            filter: {
                _from_date: '2009-01-01',
                _to_date: null,
                _mitglied_id: [],
                betrag: null,
                orderby: "datum",
                verwendungszweck: "",
                closed: '0',
                mahnungen: null
            },
            prefetch: false
        };
    },
    created() {
        this.getStoredSettings();
    },
    mounted() {
        this.$root.$on("mv::fibu::op::filter::changed", payload => {
            this.filter[payload.filterType].push(payload.value);
        });
    },
    computed: {
        storedFilter() {
            const pages = this.$store.getters.getPages;
            if (pages.fibu_offene_posten) {
                return pages.fibu_offene_posten.filter;
            }
            return null;
        }
    },
    methods: {
        getStoredSettings() {
            if (this.storedFilter) {
                this.filter = this.storedFilter;
                this.submit();
            } else {
                this.submit(false);
            }
        },
        // setDefaultFilter() {
        //     if (!this.filter._from_date) {
        //         this.filter._from_date = this.$moment()
        //             .startOf("year")
        //             .format("YYYY-MM-DD");
        //     }
        // },
        processFilter() {
            var filter = Object.assign({}, this.filter);
            var processedFilter = {};
            for (const prop in filter) {
                if (filter[prop] !== null) {
                    processedFilter[prop] = filter[prop];
                }
            }
            return processedFilter;
        },
        reset() {
            this.filter = {
                _from_date: '2009-01-01',
                _to_date: null,
                _mitglied_id: [],
                betrag: null,
                orderby: "datum",
                verwendungszweck: "",
                closed: '0',
                mahnungen: null
            };
        },
        submit(store = true) {
            FiBuBuchungApi.abort();
            const filter = this.processFilter();

            if (store) {
                this.$store.dispatch("pages", {
                    fibu_offene_posten: {
                        filter: this.filter
                    }
                });
            }
            this.$emit("submit", {
                ...this.filter
            });
        },
        sendMahnungsEvent() {
            this.filter.mahnungen = true;
            this.mahnungen.reset = false;
            this.$emit('mahnungen', { ...this.filter });
        },
        onSubmit(evt) {
            evt.preventDefault();
            if(this.mahnungen.reset) {
                this.filter.mahnungen = null;
            }
            this.submit();
        },
        onReset(evt) {
            evt.preventDefault();
            this.reset();
            this.submit();
        },
        resetCurrentPage(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.$emit('filterChanged');
            }
        }
    },
    watch: {
        'filter._mitglied_id': {
            handler(newValue, oldValue) {
                this.resetCurrentPage(newValue, oldValue);
            }
        },
        'filter.betrag': {
            handler(newValue, oldValue) {
                this.resetCurrentPage(newValue, oldValue);
            }
        },
        'filter.orderby': {
            handler(newValue, oldValue) {
                this.resetCurrentPage(newValue, oldValue);
            }
        },
        'filter.verwendungszweck': {
            handler(newValue, oldValue) {
                this.resetCurrentPage(newValue, oldValue);
            }
        },
        'filter.closed': {
            handler(newValue, oldValue) {
                this.resetCurrentPage(newValue, oldValue);
            }
        },
        'filter._from_date': {
            handler(newValue, oldValue) {
                if(oldValue !== null) {
                    this.resetCurrentPage(newValue, oldValue);
                }
            }
        },
        'filter._to_date': {
            handler(newValue, oldValue) {
                this.resetCurrentPage(newValue, oldValue);
            }
        },
    }
};
</script>
